module.exports.ca = function ca() {
  if (typeof window === 'undefined') {
    throw new Error("Can't use Cian Analytics without window object!");
  }

  if (!('ca' in window)){
    window.ca = function(evt,params){
      window.ca.q.push([evt,params]);
    };
    window.ca.q = [];
  }

  window.ca.apply(null, arguments);
}